import React from "react";
import { Box, Typography } from "@mui/material";

const BannedSharesHorizontal = ({ shares }) => {
  const bannedShares = shares.filter((s) => s.is_banned);

  if (bannedShares.length === 0) return null;

  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-GB").replace(/\//g, "-");

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        Stocks under ban as on {formattedDate} -
      </Typography>
      <Typography variant="body1" sx={{ color: "red" }}>
        {bannedShares.map((share, index) => (
          <span key={share.id}>
            {share.name}
            {index !== bannedShares.length - 1 && " || "}
          </span>
        ))}
      </Typography>
    </Box>
  );
};

export default BannedSharesHorizontal;
